module.exports = __webpack_public_path__ + "static/media/search-plus-white.594246c7.svg";